import React from 'react';
import { FlagIcon, InstagramIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="w-full bg-neutral-950 border-t border-neutral-800 py-16 px-4" data-id="element-107">
      <div className="max-w-7xl mx-auto" data-id="element-108">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12" data-id="element-109">
          {/* Brand */}
          <div data-id="element-110">
            <div className="flex items-center gap-2 mb-4" data-id="element-111">
              <img src="https://cdn.magicpatterns.com/uploads/bXrefJ2oBh4YLN5nxqUgzp/PHOTO-2024-12-29-00-15-52.jpg" alt="Motomaniac Logo" className="h-16 w-auto object-contain rounded-lg border border-orange-500/20" data-id="element-112" />
            </div>
            <p className="text-gray-400 text-sm mb-4" data-id="element-113">
              {t('footer.description')}
            </p>
            <p className="text-gray-500 text-xs" data-id="element-114">{t('footer.tagline')}</p>
          </div>

          {/* Quick Links */}
          <div data-id="element-115">
            <h4 className="font-bold text-white text-sm uppercase tracking-wider mb-4" data-id="element-116">
              {t('footer.quickLinks')}
            </h4>
            <div className="space-y-3" data-id="element-117">
              <a href="#classes" className="block text-gray-400 hover:text-orange-500 text-sm transition-colors" data-id="element-118">
                {t('footer.racingClasses')}
              </a>
              <a href="#map" className="block text-gray-400 hover:text-orange-500 text-sm transition-colors" data-id="element-119">
                {t('footer.competitionMap')}
              </a>
              <a href="#info" className="block text-gray-400 hover:text-orange-500 text-sm transition-colors" data-id="element-120">
                {t('footer.raceInfo')}
              </a>
              <a href="#register" className="block text-gray-400 hover:text-orange-500 text-sm transition-colors" data-id="element-121">
                {t('footer.registration')}
              </a>
              <a href="#gallery" className="block text-gray-400 hover:text-orange-500 text-sm transition-colors" data-id="element-122">
                {t('footer.photoGallery')}
              </a>
            </div>
          </div>

          {/* Contact */}
          <div data-id="element-123">
            <h4 className="font-bold text-white text-sm uppercase tracking-wider mb-4" data-id="element-124">
              {t('footer.contact')}
            </h4>
            <div className="space-y-3" data-id="element-125">
              <a href="mailto:info@motomaniac.lv" className="flex items-center gap-2 text-gray-400 hover:text-orange-500 text-sm transition-colors" data-id="element-126">
                <MailIcon className="h-4 w-4 flex-shrink-0" data-id="element-127" />
                info@motomaniac.lv
              </a>
              <a href="tel:+37120000000" className="flex items-center gap-2 text-gray-400 hover:text-orange-500 text-sm transition-colors" data-id="element-128">
                +371 2628 3759
              </a>
              <div className="flex items-start gap-2 text-gray-400 text-sm" data-id="element-129">
                <MapPinIcon className="h-4 w-4 flex-shrink-0 mt-0.5" data-id="element-130" />
                <span data-id="element-131">Pāvuli, Raunas pagasts, Smiltenes novads, Latvija</span>
              </div>
            </div>
          </div>

          {/* Social & Newsletter */}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-neutral-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-132">
          <p className="text-gray-500 text-xs" data-id="element-133">{t('footer.copyright')}</p>
          <div className="flex items-center gap-6" data-id="element-134">
            <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-id="element-135">
              {t('footer.privacyPolicy')}
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-id="element-136">
              {t('footer.termsConditions')}
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-id="element-137">
              {t('footer.raceRules')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}